import React, { useEffect, useState } from 'react';
import { ChevronLeft, Mail } from 'lucide-react';
import { Button } from './ui/Button';
import { OtpInput } from './ui/OtpInput';
interface EmailVerificationProps {
  email: string;
  onVerify: () => void;
  onBack: () => void;
}
export function EmailVerification({
  email,
  onVerify,
  onBack
}: EmailVerificationProps) {
  const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']);
  const [timer, setTimer] = useState(30);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  const isComplete = otp.every(d => d !== '');
  return <div className="space-y-8" data-id="element-52">
      <div data-id="element-53">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FFCC00]/15 mb-5" data-id="element-54">
          <Mail className="w-6 h-6 text-gray-900" data-id="element-55" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-56">
          Verify your email
        </h1>
        <p className="text-gray-600 leading-relaxed" data-id="element-57">
          We've sent a 6-digit verification code to{' '}
          <span className="font-semibold text-gray-900 break-all" data-id="element-58">
            {email || 'your email'}
          </span>
          . Please enter it below to secure your account.
        </p>
      </div>

      <div className="space-y-7" data-id="element-59">
        <OtpInput value={otp} onChange={setOtp} autoFocus data-id="element-60" />

        <div className="text-sm text-gray-600" data-id="element-61">
          Didn't receive the email?{' '}
          {timer > 0 ? <span className="text-gray-500" data-id="element-62">
              Resend code in{' '}
              <span className="font-medium text-gray-900" data-id="element-63">{timer}s</span>
            </span> : <button type="button" onClick={() => setTimer(30)} className="font-semibold text-gray-900 underline underline-offset-2 hover:text-[#B8860B] transition-colors" data-id="element-64">
              Resend code
            </button>}
        </div>

        <Button onClick={onVerify} fullWidth disabled={!isComplete} data-id="element-65">
          Verify
        </Button>

        <div className="text-center" data-id="element-66">
          <button onClick={onBack} className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors" data-id="element-67">
            <ChevronLeft className="w-4 h-4 mr-1" data-id="element-68" />
            Back to sign up
          </button>
        </div>
      </div>
    </div>;
}